// apps/portal/src/services/apiClient.ts
// D-1 — thin app-side re-export of the SHARED API client core
// (packages/api/src/client.ts). All HTTP/auth/envelope/presigned logic now
// lives in the shared client; this module only pins the F13c base-URL message
// and exports the app's singleton.
import {
  ApiClient,
  ApiError,
  getAuthHeaders,
  resolveApiBaseUrl as sharedResolveApiBaseUrl,
} from '@chemtracepro/api'

export { ApiError, getAuthHeaders }

// F13c — P-4: never silently target the UAT API. A missing VITE_API_URL is only
// tolerated in dev (legacy fallback to the UAT API keeps local dev working); a
// production build without it is a misconfiguration and fails fast with a clear
// error instead of talking to UAT. The message text is pinned by
// tests/unit/services/apiClient.test.ts.
export function resolveApiBaseUrl(env: Record<string, unknown> = import.meta.env): string {
  return sharedResolveApiBaseUrl(
    env,
    'VITE_API_URL is not set — refusing to target the UAT API. Configure it at build time.',
  )
}

export const API_BASE_URL = resolveApiBaseUrl()

// Portal semantics (pinned by tests/unit/services/apiClientMethods.test.ts):
// error-envelope extraction on, non-JSON success → undefined.
export const apiClient = new ApiClient({ baseUrl: API_BASE_URL })
